export default __webpack_public_path__ + "static/star-coin-d2db1da203e6453c65f38097576656cc.svg";